
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'


const Register = (props) => {


// useEffect(() => {
//     axios.get('https://localhost:7294/shopify/handshake')
//       .then(response => {
//         console.log(response)
//       })
//       .catch(error => {
//         console.log(error);
//       });
//   }, []);

    return (

        <div>
           
            <div className="home-links1">
                    <Link to="/" className="home-link navLink">
                        Register
                    </Link>
            </div>
        </div>
        

          
    ) 

}

export default Register
